<template>
  <PC :backPrev="backPrev" :showBackTip="showBackTip" v-if="!isNemoApp"/>
  <H5 :backPrev="backPrev" :showBackTip="showBackTip" v-else/>
</template>
<script>
import PC from './pc'
import H5 from './h5'
export default {
  components: {
    PC,
    H5
  },
  data() {
    return {
      showBackTip: false, // 展示后退警告
      currentNext: null // 当前后退的next函数
    }
  },
  beforeRouteEnter (to, from, next) {
    // 一场考试
    if (localStorage.has_start === 'yes') {
      next()
    } else {
      // 加一个判断是否多场考试
      if (this.isNemoApp) {
        window.location.href = window.CONFIG.m_top_noc
      } else {
        next({ name: 'login' })
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.params.noBackTip) {
      next()
    } else {
      this.showBackTip = true
      this.currentNext = next
    }
  },
  methods: {
    backPrev (isBack) {
      this.showBackTip = false
      isBack ? this.currentNext() : this.currentNext(false)
      this.currentNext = null
    }
  }
}
</script>
